// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"2071c541","346":"86dc644e","450":"8d419097","453":"d5f56df6","530":"29517b6a","591":"0adeb1fd","659":"688b0a9b","819":"8502d638","848":"ba55a36a"}[chunkId] + ".chunk.js";
};